/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_Health_Consent_RequiredInputs */

const en_guest_book_health_consent_required = /** @type {(inputs: Guest_Book_Health_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your answers may include health information, so please tick the box to send them.`)
};

const pl_guest_book_health_consent_required = /** @type {(inputs: Guest_Book_Health_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje odpowiedzi mogą zawierać informacje o zdrowiu, więc zaznacz pole, aby je wysłać.`)
};

/**
* | output |
* | --- |
* | "Your answers may include health information, so please tick the box to send them." |
*
* @param {Guest_Book_Health_Consent_RequiredInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_health_consent_required = /** @type {((inputs?: Guest_Book_Health_Consent_RequiredInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_Health_Consent_RequiredInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_health_consent_required(inputs)
	return en_guest_book_health_consent_required(inputs)
});